<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-tab-footer">
        <el-form class="box" ref="shopForm" :model="shop" label-width="70px">
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('text.name')">{{
                  shop.name
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.province')">{{
                  shop.province
                }}</el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('tenant.city')">{{
                  shop.city
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.address')">{{
                  shop.address
                }}</el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("shop.fittingRoom") }}</legend>
            <vxe-table
              :data="fittingRooms"
              ref="recordsTable"
              class="recordsTable"
              size="mini"
              border
            >
              <vxe-table-column field="name" :title="$t('text.name')" />
              <vxe-table-column
                field="action"
                :title="$t('text.action')"
                width="100"
                fixed="right"
              >
                <template v-slot="{ row }">
                  <el-button
                    type="text"
                    size="mini"
                    @click="editFittingRoom(row)"
                    >{{ $t("text.edit") }}</el-button
                  >
                  <el-popconfirm
                    :title="$t('prompt.confirmDelete')"
                    @confirm="deleteFittingRoom(row)"
                    class="mgl10"
                  >
                    <el-button slot="reference" type="text" size="mini">
                      {{ $t("text.delete") }}
                    </el-button>
                  </el-popconfirm>
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("shop.timeSlot") }}</legend>
            <vxe-table
              :data="timeSlots"
              ref="recordsTable"
              class="recordsTable"
              size="mini"
              border
            >
              <vxe-table-column field="startTime" :title="$t('shop.timeSlot')">
                <template v-slot="{ row }">
                  {{ row.startTime.slice(0, 5) }} ~
                  {{ row.endTime.slice(0, 5) }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="action"
                :title="$t('text.action')"
                width="100"
                fixed="right"
              >
                <template v-slot="{ row }">
                  <el-popconfirm
                    :title="$t('prompt.confirmDelete')"
                    @confirm="deleteTimeSlots(row)"
                  >
                    <el-button slot="reference" type="text" size="mini">
                      {{ $t("text.delete") }}
                    </el-button>
                  </el-popconfirm>
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button type="primary" size="small" @click="addFittingRoom">
        + {{ $t("shop.fittingRoom") }}
      </el-button>

      <el-button type="success" size="small" @click="addTimeSlot">
        + {{ $t("shop.timeSlot") }}
      </el-button>
    </div>
    <!-- 新增时间段 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('shop.timeSlot')])"
      :close-on-click-modal="false"
      :visible.sync="addTimeSlotDF"
      width="40%"
    >
      <el-form
        ref="addTimeSlotObjForm"
        :model="addTimeSlotObj"
        label-width="60px"
      >
        <div
          v-for="(timeSlot, timeSlotIndex) of addTimeSlotObj.timeSlots"
          :key="timeSlotIndex"
        >
          <el-row :gutter="5">
            <el-col :span="23">
              <el-form-item :label="$t('shop.timeSlot')">
                <el-time-select
                  :placeholder="$t('shop.startTime')"
                  size="small"
                  v-model="timeSlot.startTime"
                  :picker-options="{
                    start: '0:30',
                    step: '00:30',
                    end: '23:30',
                  }"
                >
                </el-time-select>
                <el-time-select
                  :placeholder="$t('shop.endTime')"
                  size="small"
                  v-model="timeSlot.endTime"
                  :picker-options="{
                    start: '0:30',
                    step: '00:30',
                    end: '23:30',
                    minTime: timeSlot.startTime,
                  }"
                >
                </el-time-select>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item label-width="0px">
                <i
                  v-if="timeSlotIndex"
                  class="el-icon-delete red"
                  @click="removeTimeSlot(timeSlotIndex)"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-button
            type="success"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="addMoreTimeSlot"
            >{{ $t("text.more") }}</el-button
          >
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addTimeSlotSubmitDoing"
          size="small"
          @click="addTimeSlotSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addTimeSlotDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增试衣间 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('shop.fittingRoom')])"
      :close-on-click-modal="false"
      :visible.sync="addFittingRoomDF"
      width="30%"
    >
      <el-form ref="addFittingRoomObjForm" :model="addFittingRoomObj">
        <div
          v-for="(
            fittingRoom, fittingRoomIndex
          ) in addFittingRoomObj.fittingRooms"
          :key="fittingRoomIndex"
        >
          <el-row :gutter="5">
            <el-col :span="16">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="fittingRoom.name"
                  :placeholder="$t('text.name')"
                  @blur="existJudgeFittingRoom(fittingRoomIndex)"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="fittingRoom._invExist || fittingRoom._localRepeat"
              :span="6"
            >
              <el-form-item>
                <small v-if="fittingRoom._invExist" class="red">{{
                  $t("rules.exist", [$t("text.name")])
                }}</small>
                <small v-if="fittingRoom._localRepeat" class="red">{{
                  $t("rules.filledIn", [$t("text.name")])
                }}</small>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <i
                  v-if="fittingRoomIndex"
                  class="el-icon-delete red"
                  @click="removeFittingRoom(fittingRoomIndex)"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="20">
              <el-button
                type="success"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="addMoreFittingRoom"
                >{{ $t("text.more") }}</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addFittingRoomSubmitDoing"
          size="small"
          @click="addFittingRoomSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addFittingRoomDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑试衣间 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('shop.fittingRoom')])"
      :close-on-click-modal="false"
      :visible.sync="editFittingRoomDF"
      width="30%"
    >
      <el-form
        ref="editFittingRoomObjForm"
        :model="editFittingRoomObj"
        label-width="60px"
      >
        <el-form-item
          :label="$t('text.name')"
          :prop="'name'"
          :rules="[
            {
              required: true,
              validator: validateFittingRoomSerialNoEdit,
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editFittingRoomObj.name" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editFittingRoomSubmitDoing"
          size="small"
          @click="editFittingRoomSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editFittingRoomDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Shop from "@/api/shop.js";
import TimeSlot from "@/api/timeSlot.js";
import FittingRoom from "@/api/fittingRoom.js";
function buildTimeSlot() {
  return {
    shopId: null,
    startTime: null,
    endTime: null,
    _localRepeat: false,
  };
}
function buildFittingRoom() {
  return {
    shopId: null,
    name: null,
    _localRepeat: false,
    _invExist: false,
  };
}

export default {
  props: {
    id: null,
  },
  mixins: [page],
  components: {},
  data() {
    var validateFittingRoomSerialNoEdit = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(new Error(this.$t("rules.required", [this.$t("text.name")])));
        return;
      }
      const index = self.fittingRooms.findIndex((f) => f.name == value);
      if (index != -1 && self.row.name !== value) {
        callback(new Error(self.$t("rules.exist", [self.$t("text.name")])));
      } else {
        callback();
      }
    };
    return {
      shop: { id: null },
      timeSlots: [],
      fittingRooms: [],
      // 新增时间段
      addTimeSlotDF: false,
      addTimeSlotObj: {
        timeSlots: [buildTimeSlot(), buildTimeSlot(), buildTimeSlot()],
      },
      addTimeSlotSubmitDoing: false,
      // 新增试衣间
      addFittingRoomDF: false,
      addFittingRoomObj: {
        // shopId: null,
        // name: null,
        fittingRooms: [buildFittingRoom(), buildTimeSlot(), buildTimeSlot()],
      },
      addFittingRoomSubmitDoing: false,
      // 编辑试衣间
      row: null,
      validateFittingRoomSerialNoEdit: validateFittingRoomSerialNoEdit,
      editFittingRoomDF: false,
      editFittingRoomObj: {
        name: null,
      },
      editFittingRoomSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    self.getShop();
  },
  methods: {
    getShop() {
      const self = this;
      self.loadingStart();
      Shop.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.shop = res.data.entity;
          self.getTimeSlots();
          self.getFittingRooms();
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getTimeSlots() {
      const self = this;
      TimeSlot.findByShopId(self.shop.id).then(function (res) {
        if (res.status === 200) {
          self.timeSlots = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getFittingRooms() {
      const self = this;
      FittingRoom.findByShopId(self.shop.id).then(function (res) {
        if (res.status === 200) {
          self.fittingRooms = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //新增时间段
    addTimeSlot() {
      const self = this;
      self.addTimeSlotObj.timeSlots = [
        buildTimeSlot(),
        buildTimeSlot(),
        buildTimeSlot(),
      ];
      self.addTimeSlotSubmitDoing = false;
      self.addTimeSlotDF = true;
    },
    removeTimeSlot(idx) {
      this.addTimeSlotObj.timeSlots.splice(idx, 1);
    },
    addMoreTimeSlot() {
      this.addTimeSlotObj.timeSlots.push(buildTimeSlot());
    },
    addTimeSlotSubmit() {
      const self = this;
      this.$refs.addTimeSlotObjForm.validate((valid) => {
        if (valid) {
          const items = self.addTimeSlotObj.timeSlots.filter(
            (t) => t.startTime != null && t.endTime != null
          );
          for (const item of items) {
            item.startTime = item.startTime + ":00";
            item.endTime = item.endTime + ":00";
            item.shopId = self.shop.id;
          }
          self.addTimeSlotSubmitDoing = true;
          TimeSlot.insertBatch(items).then(function (res) {
            self.addTimeSlotSubmitDoing = false;
            self.addTimeSlotDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.getTimeSlots();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    deleteTimeSlots(row) {
      const self = this;
      TimeSlot.delete(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.getTimeSlots();
        } else {
          self.sysError();
        }
      });
    },
    //
    addFittingRoom() {
      const self = this;
      // self.addFittingRoomObj.name = null;
      self.addFittingRoomObj.fittingRooms = [
        buildFittingRoom(),
        buildFittingRoom(),
        buildFittingRoom(),
      ];
      // self.addFittingRoomObj.shopId = self.shop.id;
      self.addFittingRoomSubmitDoing = false;
      self.addFittingRoomDF = true;
    },
    removeFittingRoom(idx) {
      this.addFittingRoomObj.fittingRooms.splice(idx, 1);
    },
    addMoreFittingRoom() {
      this.addFittingRoomObj.fittingRooms.push(buildFittingRoom());
    },
    existJudgeFittingRoom(idx) {
      const self = this;
      self.addFittingRoomObj.fittingRooms[idx]._invExist = false;
      self.addFittingRoomObj.fittingRooms[idx]._localRepeat = false;
      if (
        self.addFittingRoomObj.fittingRooms[idx].name != null &&
        self.addFittingRoomObj.fittingRooms[idx].name.trim() !== ""
      ) {
        const serialNos = self.fittingRooms.map((s) => s.name.trim());
        if (
          serialNos.includes(
            self.addFittingRoomObj.fittingRooms[idx].name.trim()
          )
        ) {
          this.addFittingRoomObj.fittingRooms[idx]._invExist = true;
          return;
        }
        // 本地过滤
        const iis = self.addFittingRoomObj.fittingRooms.filter(function (s) {
          return (
            (s.name || "").trim() ===
            self.addFittingRoomObj.fittingRooms[idx].name.trim()
          );
        });
        if (iis.length > 1) {
          self.addFittingRoomObj.fittingRooms[idx]._localRepeat = true;
        }
      }
    },
    addFittingRoomSubmit() {
      const self = this;
      this.$refs.addFittingRoomObjForm.validate((valid) => {
        if (valid) {
          const items = this.addFittingRoomObj.fittingRooms.filter(function (
            item
          ) {
            return item.name !== null && item.name.trim() !== "";
          });

          if (items.length === 0) {
            self.$message({
              message: this.$t("prompt.atLeastOneValidDataFillIn"),
              type: "warning",
            });
            return;
          }

          const errDatas = items.filter(
            (s) => s._invExist === true || s._localRepeat === true
          );
          if (errDatas.length !== 0) {
            self.$message({
              message: this.$t("prompt.errorMessage"),
              type: "warning",
            });
            return;
          }
          for (const item of items) {
            item.shopId = self.shop.id;
          }
          self.addFittingRoomSubmitDoing = true;
          FittingRoom.insertBatch(items).then(function (res) {
            self.addFittingRoomSubmitDoing = false;
            self.addFittingRoomDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.getFittingRooms();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    editFittingRoom(row) {
      const self = this;
      self.row = row;
      self.editFittingRoomObj.name = row.name;
      self.editFittingRoomSubmitDoing = false;
      self.editFittingRoomDF = true;
    },
    editFittingRoomSubmit() {
      const self = this;
      this.$refs.editFittingRoomObjForm.validate((valid) => {
        if (valid) {
          self.editFittingRoomSubmitDoing = true;
          FittingRoom.update(self.row.id, self.editFittingRoomObj).then(
            function (res) {
              self.editFittingRoomSubmitDoing = false;
              self.editFittingRoomDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.editSuccess"),
                  type: "success",
                });
                self.getFittingRooms();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    deleteFittingRoom(row) {
      const self = this;
      FittingRoom.delete(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.getFittingRooms();
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>